import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteChatForMe } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useDeleteChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (chatId: number) => deleteChatForMe(chatId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ChatsQueryKeys.Chats] });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
